/** @flow */
export type TimeResolution = 'HOURS' | 'MINUTES'

export const RESOLUTIONS: TimeResolution[] = [
  'HOURS', 'MINUTES',
];

export function convertSeconds(input: number, resolution: TimeResolution) {
  switch (resolution) {
    case 'HOURS':
      return input / 3600;
    case 'MINUTES':
      return input / 60;
    default:
      return input;
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/domain/TimeResolution.js